module.exports = __webpack_public_path__ + "img/nav-award-act.063f37ea.png";